import React, { useEffect } from 'react';
import { TouchableOpacity, View } from 'react-native';
import {
  Button,
  DefaultScreenContainer,
  InsuranceCardBenefit,
  OfferBanner,
  Text,
} from '~/components';
import useAppNavigation from '~/hooks/useAppNavigation';
import { isWeb } from '~/utils/device';

import cashSVG from '~/assets/svgs/cash.svg';
import percentageSVG from '~/assets/svgs/percentage-loan.svg';
import LoanSVG from '~/assets/svgs/loan.svg';

import BannerImg from '~/assets/img/banners/personal-loan-banner.png';
import BannerImgDesk from '~/assets/img/banners/personal-loan-banner-desk.png';
import type { Benefit } from '~/components/InsuranceCardBenefit';
import { journeyLogUseCase } from '~/useCases/PSF/JourneyLogUseCase';
import { useUserInfoStore } from '~/stores/userInfo';

import { useSalesFunnel } from '~/stores';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import GeneralInfoFooter from '../components/GeneralInfoFooter';
const INSURANCE_TYPE = 'unemployment-assistance';

const BENEFITS: Benefit[] = [
  {
    icon: LoanSVG,
    title: 'Realize Sonhos',
    description: (
      <Text className="text-sm">
        Com crédito pessoal Marisa, você pode realizar sonhos.
      </Text>
    ),
  },
  {
    icon: percentageSVG,
    title: 'Taxas',
    description: (
      <Text className="text-sm">
        Taxas competitivas que você só encontra na Marisa
      </Text>
    ),
  },
  {
    icon: cashSVG,
    title: 'Empréstimos',
    description: (
      <Text className="text-sm">
        Crédito descomplicado com a segurança que precisa
      </Text>
    ),
  },
];
const PersonalLoanDetails = () => {
  const { goBack } = useAppNavigation();
  const { init } = useSalesFunnel();

  const id = useUserInfoStore((state) => state.user?.id);

  useEffect(() => {
    if (id) {
      journeyLogUseCase(useUserInfoStore.getState().user, 'ASSIST_DESEMPREGO');
    }
  }, [id, init]);

  return (
    <DefaultScreenContainer>
      <OfferBanner
        hireInsurance={{
          showButton: true,
          type: INSURANCE_TYPE,
          label: isWeb
            ? 'Consulte a disponibilidade em nossas lojas'
            : 'Consulte a disponibilidade \nem nossas lojas',
          onPressButton: MarisaAppUtils.goToStoresList,
        }}
        images={{
          mobile: BannerImg,
          web: { banner: BannerImgDesk },
        }}
        insuranceName="Crédito Pessoal"
        insuranceDetail="Mais Possibilidades para seus planos"
      />

      <View className="px-6">
        <View className="md:items-center md:justify-center items-start justify-start">
          <Text className="mt-6 sm:mt-16 text-gray-700 text-[22px]">
            O que é o Crédito Pessoal?
          </Text>

          <Text className="mt-4 text-gray-400 md:text-center text-[16px] leading-6">
            Dinheiro na conta rápido e sem burocracia
          </Text>
        </View>

        {isWeb && (
          <View className="mt-10 mb-2 bg-gray-100 h-[1px] invisible md:visible" />
        )}

        <View className="bg-credit-200 p-3 rounded-lg mt-8">
          <View className="border border-primary-600 rounded-lg py-6 px-3 bg-light-100 shadow-sm">
            <Text className="text-center text-primary-600 font-medium">
              Compareça em uma de nossas lojas Marisa mais próxima de você.
            </Text>
          </View>
        </View>

        <Text className="mt-3 text-xl text-gray-700 md:items-center md:justify-center md:text-center md:mb-6">
          Conheça os benefícios:
        </Text>

        <View className="lg:flex-row lg:justify-center">
          {BENEFITS.map((benefit, index) => (
            <InsuranceCardBenefit data={benefit} type="loan" key={index} />
          ))}
        </View>

        <View className="items-center justify-center p-6 bg-feedback-neutral-bkg rounded-lg mt-8 mb-7">
          <Text className="text-xs text-justify text-gray-400 ">
            <Text className="font-bold">Crédito Pessoal:</Text> “MARISA LOJAS
            S.A.), (Lojas Marisa),{' '}
            <Text className="font-bold">CNPJ Nº 61.189.288/0001-89</Text>, com
            sede na Cidade de São Paulo, Estado de São Paulo, na (Rua James
            Holland, 422, CEP 01138-000, Bairo Barra Funda) é correspondente
            bancária da instituição financeira Credsystem Sociedade de Crédito
            Direto S.A. (Credsystem), responsável pela concessão de crédito
            pessoal, inscrita no CNPJ sob o Nº 39.664.698/0001-85 com sede na
            Alameda Rio Negro, 161, 3º andar, sala 304-B, Bairro Alphaville
            Industrial, Cidade de Barueri, Estado de São Paulo, CEP 06454-000.
            Em caso de dúvidas, entre em contato com a Credsystem através do
            WhatsApp disponível 24h por dia: (11) 4003-3900. Agora, caso queira
            falar com a Central de Relacionamento da Credsystem, ligue para (11)
            4003-3900, de segunda a sábado das 8h às 22h, aos domingos e
            feriados das 9h às 20h. Caso você esteja em outra localidade, ligue
            de um telefone fixo para 0800 729 3900. Se passou anteriormente pelo
            nosso atendimento via Central de Relacionamento ou WhatsApp, mas
            ainda não está satisfeito, entre em contato com a Ouvidoria de um
            telefone fixo (telefone 0800 777 5297), com o número do seu
            protocolo de atendimento em mãos, de segunda à sexta das 9h às 17h,
            exceto feriados. A atividade de correspondente bancário é uma
            atividade regulada pelo Banco Central do Brasil, nos termos da
            Resolução CMN n° 4.935 de 29/7/2021. A disponibilidade do Empréstimo
            Pessoal está sujeita à análise de crédito. Cada cliente poderá
            realizar uma contratação durante o período de vigência da oferta
            junto a Credsystem. Haverá incidência de IOF sobre o valor do
            Empréstimo Pessoal. As taxas de juros, prazos e limites de crédito
            são definidos conforme política de crédito e avaliação individual de
            cada proponente, em conformidade com as diretrizes e normativas do
            Banco Central do Brasil.”
          </Text>
        </View>

        <Text className="text-gray-400 text-sm text-center my-4">
          Acesse nosso canal de transparência{' '}
          <Text
            className="text-center text-primary-600 font-bold"
            onPress={() =>
              MarisaAppUtils.openUrl('https://www.credsystem.com.br/')
            }
          >
            https://www.credsystem.com.br/
          </Text>
        </Text>

        <Text className="text-gray-400 text-xs text-center my-4">
          * Todas as solicitações são sujeitas à análise de crédito, consultar
          condições de elegibilidade ao produto.
        </Text>

        <Button onPress={MarisaAppUtils.goToStoresList}>
          Consulte a disponibilidade em nossas lojas
        </Button>

        <GeneralInfoFooter className="mt-8 gap-2 " />
      </View>

      <View className="py-4 px-6 items-center justify-center lg:mx-auto lg:w-[328px]">
        {isWeb && (
          <TouchableOpacity onPress={() => goBack()}>
            <Text className="text-primary-600 uppercase font-medium mt-4 text-xs">
              Voltar
            </Text>
          </TouchableOpacity>
        )}
      </View>
    </DefaultScreenContainer>
  );
};

export default PersonalLoanDetails;
